import Styles from './ImportModal.module.scss'
import { Modal } from 'almanac-ui/Modal'

interface CancelImportProps {
  onClose: (yes: boolean) => void
}

export const CancelImport = ({ onClose }: CancelImportProps) => {
  return (
    <>
      <Modal.Content>
        <div className={Styles.cancelText}>Are you sure you want to cancel your import process? </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton onPress={() => onClose(false)} variant="tertiary" size="lg">
            No, continue import
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton onPress={() => onClose(true)} size="lg">
            Yes, cancel import
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </>
  )
}
